import * as React from "react";
import { useEffect, useState } from "react";
import { useAppSelector } from "../app/hooks";
import { useAppDispatch } from "../app/store";
import { useSubmitReserveRequestMutation } from "../data/api/api";
import { BestAvailableState, MiniCartModel, ReserveRequest, ReserveResponse } from "../data/interfaces/types";
import loadingSlice from "../data/slices/loading-slice";
import miniCartModelSlice from "../data/slices/mini-cart-slicer";

export const MiniCart: React.FC = () => {
    const bestAvailableText = useAppSelector((state: BestAvailableState) => state.bestAvailableText);
    const miniCart = useAppSelector((state: BestAvailableState) => state.miniCartModel);
    const [currentMiniCart, setCurrentMiniCart] = useState(miniCart);
    const pageId = useAppSelector((state: BestAvailableState) => state.pageId);
    const bestAvailableModel = useAppSelector((state: BestAvailableState) => state.bestAvailableModel);
    const [currentBestAvailableModel, setCurrentBestAvailableModel] = useState(bestAvailableModel);
    const dispatch = useAppDispatch();
    const [submitReserve] = useSubmitReserveRequestMutation();
    
    useEffect(() => { setCurrentMiniCart(miniCart) }, [miniCart])
    useEffect(() => { setCurrentBestAvailableModel(bestAvailableModel) }, [bestAvailableModel])

    const currencyFormatter = (amount: number): string => {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        return formatter.format(amount);
    }

    function handleAddToCart() {
        submitReserveRequest();
    }

    const submitReserveRequest = () => {
        dispatch(loadingSlice.actions.setIsLoading(true));
        const request: ReserveRequest = {
            isExchange: currentBestAvailableModel.isExchange,
            pageId: pageId,
            performanceId: currentBestAvailableModel.currentPerformance.performanceId,
            priceTypeQuantities: currentMiniCart.priceTypeQuantities,
            wheelchairActivityTypes: currentBestAvailableModel.activityTypes,
            usePayWhatYouCan: currentBestAvailableModel.currentPerformance.usePayWhatYouCan
        };
        dispatchSubmitReserve(request);
    }

    const dispatchSubmitReserve = async (request: ReserveRequest) => {
        const response: ReserveResponse = await submitReserve(request).unwrap();
        if (response.success) {
            redirectToCartPage();
        } else {
            if (response.redirectToCart) {
                redirectToCartPage();
            }

            let newMiniCartModel: MiniCartModel = {
                priceTypeQuantities: currentMiniCart.priceTypeQuantities,
                subtotal: currentMiniCart.subtotal,
                disableAddToCartButton: currentMiniCart.disableAddToCartButton,
                showError: true,
                errorMessage: response.errorMessage
            };

            setCurrentMiniCart(newMiniCartModel);
            dispatch(miniCartModelSlice.actions.replaceMiniCart(newMiniCartModel));
            dispatch(loadingSlice.actions.setIsLoading(false));
        }
    }

    const redirectToCartPage = () => {
        window.location.href = bestAvailableText.addToCartRedirectUrl;
    }

    return (
        <div className="ace-minicart">
            <div className="ace-minicart-inner theme-light">
                {
                    currentMiniCart?.showError &&
                    <div className="error-message" dangerouslySetInnerHTML={{ __html: currentMiniCart.errorMessage }} />
                }
                {
                    currentMiniCart?.priceTypeQuantities?.length > 0 &&
                    <ul>
                        {
                            currentMiniCart.priceTypeQuantities.map((ptQuantity, index) => {
                                return (
                                    <li key={index} className="ace-minicart-item">
                                        <span>({ptQuantity.quantity}) {ptQuantity.priceTypeDescription}</span>
                                        <span className="bold">{currencyFormatter(ptQuantity.totalAmount)}</span>
                                    </li>
                                )
                            })
                        }
                    </ul>
                }
                <div className="ace-minicart-subtotal">
                    <span>{bestAvailableText.subtotalLabel}</span>
                    <span className="bold">{currencyFormatter(currentMiniCart.subtotal)}</span>
                </div>
                <div className="stack-md">
                    {
                        bestAvailableModel.showFeesIncludedMessaging && 
                        <div className="rich-text" dangerouslySetInnerHTML={{ __html: bestAvailableText.feesIncludedMessaging }} />
                    }
                    <button type="button" className="btn-primary btn-full-width" disabled={currentMiniCart.disableAddToCartButton} onClick={handleAddToCart}>
                        {bestAvailableText.addToCartButtonText}
                    </button>
                </div>
            </div>
        </div>
    )
}